import { useCallback, useRef } from 'react';

import { useActionInput } from '..';

const createFileUploader = (allowedExtensions?: string[]) => {
	const el = document.createElement('input');

	el.setAttribute('type', 'file');
	el.setAttribute('data-testid', 'use-file-upload-input');
	el.style.display = 'none';

	/* istanbul ignore else - allowed extensions are hard coded into useBonusInput */
	if (allowedExtensions) {
		el.setAttribute('accept', allowedExtensions.map((ext) => `.${ext}`).join(','));
	}

	document.body.appendChild(el);

	return el;
};

export const useFileSelector = ({ allowedExtensions }: { allowedExtensions?: string[] } = {}) => {
	const { onUpload } = useActionInput();
	const extensionsRef = useRef(allowedExtensions);

	return useCallback(() => {
		let file: File | undefined;

		const el = createFileUploader(extensionsRef.current);

		const removeInputEl = () => {
			if (!file) {
				el.remove();
			}

			window.removeEventListener('focus', removeInputEl);
		};

		window.addEventListener('focus', removeInputEl);

		el.addEventListener('change', (e: Event) => {
			// `file` is stored so when focus is returned to the window
			// we can check if the file exists. If it does, this was through the
			// file interface, in which case the file input is removed as it is
			// no longer needed
			file = (e.target as HTMLInputElement).files?.[0];
			/* istanbul ignore else - unable to test as firing change will always be with a file */
			if (file) {
				onUpload(file);
			}
			el.remove();
		});

		el.click();
	}, [onUpload]);
};
